/*
  <ia-onetrust-bridge> — the theme side of the OneTrust cookie banner.
  Rendered by snippets/ia-onetrust.liquid right after the SDK stub.

  Klaviyo closes its signup popup on any touchstart / mousedown that reaches
  the document from outside the popup. The cookie banner is outside it, so a
  tap on Accept used to dismiss the popup as a side effect. The guard stops
  those pointer events from leaving the banner; the banner's own buttons keep
  working because their handlers run on click, which still bubbles. Ported
  from the legacy theme's klaviyo-popup snippet.

  The banner is injected by the SDK whenever it decides to, so the element
  watches the document until it appears, then guards it once.
*/
const BANNER_ID = 'onetrust-banner-sdk'
const GUARDED_EVENTS = ['touchstart', 'mousedown', 'pointerdown']

class IaOnetrustBridge extends HTMLElement {
  connectedCallback() {
    this.watchBanner()
  }

  disconnectedCallback() {
    this.mountObserver?.disconnect()
  }

  watchBanner() {
    const banner = document.getElementById(BANNER_ID)
    if (banner) return this.guardBanner(banner)
    this.mountObserver = new MutationObserver(() => {
      const mounted = document.getElementById(BANNER_ID)
      if (!mounted) return
      this.mountObserver.disconnect()
      this.guardBanner(mounted)
    })
    this.mountObserver.observe(document.documentElement, { childList: true, subtree: true })
  }

  guardBanner(banner) {
    GUARDED_EVENTS.forEach((type) => {
      banner.addEventListener(type, this.stopPropagation)
    })
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
}

if (!customElements.get('ia-onetrust-bridge')) {
  customElements.define('ia-onetrust-bridge', IaOnetrustBridge)
}
